module.exports = __webpack_public_path__ + "media/images/how_it_works/step-2-405c33a75e30fefa6d96003dff10d740.svg";